module.exports = __webpack_public_path__ + "img/ggdowload.bfedbf7a.png";